import React from "react";
import { useNavigate } from 'react-router-dom'

import NeedHelp from '../need-help'

import { scrollError } from '../../helpers'

interface CreditCardSubmitButtonsProps {
  [key: string]: any
}

const CreditCardSubmitButtons: React.FC<CreditCardSubmitButtonsProps> = (props:any) => {

  const navigate = useNavigate()

  return (
    <>
      <div className="row">
        <div className="actions card-details-submit clearfix box">
          <div className="medium-6 columns">
            <button type="submit" id="m-make-payment" className="btn-cta go" onClick={() => {scrollError()}}>Make payment</button>
            <button type="button" id="m-back-button-4c" className="btn-cta back" onClick={() => navigate(-1)}>Back</button>
          </div>
          <div className="medium-6 columns">
            <div className="mobile-divider show-for-small-only"></div>
            <NeedHelp />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditCardSubmitButtons;